<div class="modal-body content width-900 height-900">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      Bild bearbeiten
    </span>
    <div class="layout-auto-1">
      <div class="grid cols-2">
        <exg-input [(ngModel)]="newName"
                   [caption]="'Dateiname: '"
                   name="dokName"
                   type="text">
        </exg-input>
        <exg-select [(ngModel)]="dokTypIndex" [list]="enumSvc.getEnumerationList('DokTyp')" listdisplay="enmText"
                    name="typ" [caption]="enumSvc.getFieldCaption('Dokument', 'dok_enmIdent_DokTyp')" >
        </exg-select>
        <!--<app-exg-select-enumeration
                                    [(value)]="dok_enmIdent_DokTyp"
                                    [caption]="enumSvc.getFieldCaption('Dokument', 'dok_enmIdent_DokTyp')"
                                    enumerationName="DokTyp"
                                    name="type">
        </app-exg-select-enumeration>-->
      </div>
      <ejs-imageeditor #imageEditor (created)="editorCreated()"
                       [toolbar]="toolbarItems"
                       locale="de-DE"></ejs-imageeditor>
    </div>
    <div style="height: auto" class="spawn-modal-actions typo-small">
      <button (click)="save()"
              *ngIf="baseImageIsEdited"
              class="md-btn">
        Speichern
      </button>
      <button (click)="resetCopy()"
              *ngIf="baseImageIsEdited"
              class="md-btn">
        Zurücksetzen
      </button>
      <button (click)="saveAsNew()" class="md-btn">Speichern unter</button>
      <button (click)="close()" class="md-btn">
        Abbrechen
      </button>
    </div>
  </div>
</div>
